import scrollIntoView from 'scroll-into-view-if-needed';

const supportsNativeSmoothScroll =
  'scrollBehavior' in document.documentElement.style;

const preprocessOptions = (
  options?: ScrollIntoViewOptions | ScrollToOptions
): ScrollIntoViewOptions | ScrollToOptions => {
  const effectiveOptions: ScrollIntoViewOptions = {
    ...options,
  };
  effectiveOptions.behavior =
    effectiveOptions.behavior === 'smooth' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ? 'auto'
      : effectiveOptions.behavior;
  return effectiveOptions;
};

export const scrollTo = (options: ScrollToOptions): void => {
  const effectiveOptions: ScrollToOptions = preprocessOptions(options);
  if (supportsNativeSmoothScroll) {
    return window.scrollTo(effectiveOptions);
  }
  return window.scrollTo(effectiveOptions.left || 0, effectiveOptions.top || 0);
};

export const scrollElementIntoView = (
  element: HTMLElement,
  options?: ScrollIntoViewOptions
): void => {
  const effectiveOptions: ScrollIntoViewOptions = preprocessOptions(options);
  scrollIntoView(element, effectiveOptions);
};
